import { render, staticRenderFns } from "./qc.vue?vue&type=template&id=4954725e&scoped=true&"
import script from "./qc.vue?vue&type=script&lang=js&"
export * from "./qc.vue?vue&type=script&lang=js&"
import style0 from "./qc.vue?vue&type=style&index=0&id=4954725e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954725e",
  null
  
)

export default component.exports